$(document).ready(function () {
    const $form = $('#message');
    const $submit = $form.find('.js-get-an-offer');
    const $feedback = $form.find('.form-feedback');
    const $phone = $form.find('#phone_number');

    // Form Get in touch
    function showError($input, msg) {
        const $err = $input.closest('.form-group').find('.field-error');
        $err.text(msg).css('opacity', 1);
        $err.addClass('error-msg');
        $input.addClass('invalid');
    }

    function clearErrors() {
        $form.find('.field-error').css('opacity', 0).text('');
        $form.find('.invalid').removeClass('invalid');
        $feedback.hide().text('');
    }

    function isValidEmail(email) {
        const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
        return re.test(email);
    }

    function isValidPhone(phone) {
        if (!phone || phone.trim() === '') {
            return false;
        }
        const re = /^[0-9+\s().-]{6,}$/;
        return re.test(phone);
    }

    function isValidOrganization(org) {
        return org && org.trim().length >= 3;
    }

    function isValidCountOfLines(count) {
        return count && count > 0;
    }

    function validateForm() {
        clearErrors();

        const name = $.trim($('#full_name').val());
        const email = $.trim($('#email').val());
        const message = $.trim($('#text-message').val());
        const phone = $.trim($phone.val());
        const organization = $.trim($('#organization').val());
        const countOfLines = $.trim($('#lines-count').val());
        let valid = true;

        // Name validation
        if (!name) {
            showError($('#full_name'), 'Name is required. Please enter your full name.');
            valid = false;
        } else if (name.length < 3) {
            showError($('#full_name'), 'Name is too short. Please enter at least 3 characters.');
            valid = false;
        }

        // Email validation
        if (!email) {
            showError($('#email'), 'Business email is required.');
            valid = false;
        } else if (!isValidEmail(email)) {
            showError($('#email'), 'Invalid email format. Please use format: name@company.com');
            valid = false;
        }

        // Organization validation
        if (!organization) {
            showError($('#organization'), 'Company name is required.');
            valid = false;
        } else if (!isValidOrganization(organization)) {
            showError($('#organization'), 'Company name is too short. Please enter at least 3 characters.');
            valid = false;
        }

        // Lines count validation
        if (!countOfLines) {
            showError($('#lines-count'), 'Number of lines is required.');
            valid = false;
        } else if (!isValidCountOfLines(countOfLines)) {
            showError($('#lines-count'), 'Invalid number. Please enter a valid number greater than 0.');
            valid = false;
        }

        // Phone validation (optional field)
        if (!isValidPhone(phone)) {
            showError($phone, 'Phone number is required and must be valid (numbers, spaces, and symbols: + ( ) . -)');
            valid = false;
        }

        // Message validation
        if (!message) {
            showError($('#text-message'), 'Message is required. Please describe your use case.');
            valid = false;
        } else if (message.length < 10) {
            showError($('#text-message'), 'Message is too short. Please provide at least 10 characters.');
            valid = false;
        }

        if (!valid) {
            // focus first invalid field for accessibility
            const $firstInvalid = $form.find('.invalid').first();
            if ($firstInvalid.length) {
                $firstInvalid.focus();
            }
        }

        // Update submit button state
        if (valid) {
            $submit.prop('disabled', false).removeClass('disabled');
        } else {
            $submit.prop('disabled', true).addClass('disabled');
        }

        // Update submit button state
        $submit.prop('disabled', true).addClass('disable');

        return valid;
    }

// Real-time validation on input - only clear errors for current field
    $form.on('input', 'input, textarea', function () {
        const $input = $(this);
        $input.closest('.form-group').find('.field-error').css('opacity', 0).text('');
        $input.removeClass('invalid');
        $feedback.hide().text('');

        // Check if all fields are filled to enable/disable submit button
        const allFilled = checkAllFieldsFilled();
        $submit.prop('disabled', !allFilled).toggleClass('disabled', !allFilled);
    });

    function checkAllFieldsFilled() {
        const name = $.trim($('#full_name').val());
        const email = $.trim($('#email').val());
        const message = $.trim($('#text-message').val());
        const phone = $.trim($phone.val());
        const organization = $.trim($('#organization').val());
        const countOfLines = $.trim($('#lines-count').val());

        return name && email && message && phone && organization && countOfLines;
    }

    $form.on('submit', function (e) {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        // Disable button to prevent multiple submits
        $submit.prop('disabled', true).text('Sending...');

        // Send via AJAX
        $.ajax({
            type       : 'POST',
            url        : 'https://myaccount.keepgo.com/send_form',
            data       : $form.serialize(),
            crossDomain: true,
            timeout    : 15000 // 15 second timeout
        })
            .done(function (response) {
                // Check for backend validation errors
                if (response && response.errors) {
                    // Display backend validation errors
                    $.each(response.errors, function (field, messages) {
                        const $field = $('#' + field);
                        if ($field.length && messages.length > 0) {
                            showError($field, messages[0]);
                        }
                    });
                    $feedback.css('color', '#c0392b').text('Please fix the errors and try again.').show();
                    $submit.prop('disabled', false).text('Get in touch');
                } else {
                    // Success
                    $feedback.css('color', '#27ae60').text('Message sent successfully. Thank you!').show();
                    $form[0].reset();
                    $submit.prop('disabled', true).text('Get in touch'); // Reset text and keep disabled after success

                    // Track with Google Analytics if available
                    try {
                        ga('send', 'event', {
                            eventCategory: 'form',
                            eventAction  : 'submit',
                            eventLabel   : 'contact-form',
                            eventValue   : 1
                        });
                    } catch (error) {
                        console.log('GA tracking not available');
                    }
                }
            })
            .fail(function (xhr, status, error) {
                let errorMessage;

                if (status === 'timeout') {
                    errorMessage = 'Request timed out. Please check your connection and try again.';
                } else if (status === 'error' && xhr.status === 0) {
                    errorMessage = 'Network error. Please check your connection and try again.';
                } else if (xhr.status >= 500) {
                    errorMessage = 'Server error. Please try again later.';
                } else if (xhr.responseJSON && xhr.responseJSON.message) {
                    errorMessage = xhr.responseJSON.message;
                } else {
                    errorMessage = 'Something went wrong. Please try again.';
                }

                $feedback.css('color', '#c0392b').text(errorMessage).show();
                $submit.prop('disabled', false).text('Get in touch');
            });
    });

    $('.item-quantity').on('change', function () {
        $('#update-cart').click();
    });

    function addItem(form_id) {
        $.ajax({
            type    : 'POST',
            url     : '/cart/add.js',
            dataType: 'json',
            data    : $('#' + form_id).serialize(),
            success : Shopify.onSuccess,
            error   : Shopify.onError
        });
    }

    $(".addtocart").click(function (e) {
        var elem = $(this)
        $(elem).prop("disabled", true)

        e.preventDefault();
        addItem('add-item-form');
    });

    $('#product .extra-block h4').on('click', function () {
        $(this).parent().toggleClass('show-extra');
    });

    Shopify.onSuccess = function () {

        var elem = $('.addtocart');

        elem.removeAttr("disabled");

        var quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;

        function animate() {

            $("#cart-animation").show();

            var addtocartWidth = elem.outerWidth() / 2
            var addtocartHeight = elem.outerHeight() / 2

            var addtocartLeft = elem.offset().left + addtocartWidth;
            var addtocartTop = $(elem).offset().top + addtocartHeight;

            var buttonAreaWidth = $("#cart-target").outerWidth();
            var buttonAreaHeight = $("#cart-target").outerHeight();

            var buttonAreaLeft = ($("#cart-target").offset().left + buttonAreaWidth / 2 - $("#cart-animation").outerWidth() / 2) - 4;
            var buttonAreaTop = ($("#cart-target").offset().top + buttonAreaWidth / 2 - $("#cart-animation").outerHeight() / 2) - 4;

            var path = {
                start: {
                    x     : addtocartLeft,
                    y     : addtocartTop,
                    angle : 190.012,
                    length: 0.2
                },
                end  : {
                    x     : buttonAreaLeft,
                    y     : buttonAreaTop,
                    angle : 90.012,
                    length: 0.50
                }
            };

            $('#cart-animation').text(quantity).animate(
                {
                    path: new $.path.bezier(path)
                },
                1200,
                function () {
                    $("#cart-animation").fadeOut(500, function () {
                        $(elem).prop("disabled", false)
                        var cartCount = parseInt($('#cart-count').text()) + quantity;
                        $('#cart-count').text(cartCount)
                    })
                }
            );
        }

        animate();
    };

    Shopify.onError = function (XMLHttpRequest, textStatus) {
        // Shopify returns a description of the error in XMLHttpRequest.responseText.
        // It is JSON.
        // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
        var data = JSON.parse(XMLHttpRequest.responseText);
        if (!!data.message) {
            alert(data.message + '(' + data.status + '): ' + data.description);
        } else {
            alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
        }

        $('.addtocart').removeAttr("disabled");
    };

    Shopify.fullMessagesFromErrors = function (errors) {
        var fullMessages = [];
        jQuery.each(errors, function (attribute, messages) {
            jQuery.each(messages, function (index, message) {
                fullMessages.push(attribute + ' ' + message);
            });
        });
        return fullMessages;
    };

});

jQuery(window).load(function () {

    if ($('.slides li').length > 1) {

        $('.flexslider').flexslider({
            slideshow        : true,
            animationDuration: 700,
            slideshowSpeed   : 6000,
            animation        : "slide",
            controlsContainer: ".flex-controls",
            controlNav       : false,
            keyboardNav      : true
        }).hover(function () {
            $('.flex-direction-nav').fadeIn();
        }, function () {
            $('.flex-direction-nav').fadeOut();
        });

    }

    $("select.loc_on_change").change(function () {
        if ($(this).attr("value") === "#") {
            return false;
        }
        window.location = $(this).attr("value");
    });

});

jQuery(document).ready(function ($) {

    $("a.zoom").click(function (event) {
        event.preventDefault();
        return false;
    });

    $('#product .thumbs a').click(function () {

        $('#placeholder').attr('href', $(this).attr('href'));
        $('#placeholder img').attr('src', $(this).attr('data-original-image'))

        $('#zoom-image').attr('href', $(this).attr('href'));
        return false;
    });

    $('input[type="submit"], input.btn, button').click(function () { // remove ugly outline on input button click
        $(this).blur();
    });

    function isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    if (isMobile()) {
        $("li.dropdown").click(function () {
            if ($(this).children('ul.dropdown').css('display') == 'block') {
                $(this).children('.dropdown').stop();
                $(this).children('.dropdown').animate({
                    opacity: 0.0
                }, 400, function () {
                    $(this).hide();
                });
            } else {
                $('li.dropdown').children('.dropdown').hide();
                $(this).children('.dropdown').show();
                $(this).children('.dropdown').stop();
                $(this).children('.dropdown').animate({
                    opacity: 1.0
                }, 200);
            }
        });
    } else {

        $("li.dropdown").hover(function () {

            $("li.dropdown").removeClass('hover-menu');
            $(this).addClass('hover-menu');

            $(this).children('.dropdown').show();
            $(this).children('.dropdown').stop();
            $(this).children('.dropdown').animate({
                opacity: 1.0
            }, 200);
        }, function () {
            $(this).children('.dropdown').stop();
            $(this).children('.dropdown').animate({
                opacity: 0.0
            }, 400, function () {
                $(this).hide();
                $(this).closest('li.dropdown').removeClass('hover-menu');
            });
        });
    }

    var menu = $('#accounting .my-account-menu');
    $('#accounting>a, #accounting .my-account-menu').hover(function () {
        menu.show();
        menu.stop();
        menu.animate({opacity: 1.0}, 200);
    }, function () {
        menu.stop();
        menu.animate({opacity: 0.0}, 400, function () {
            menu.hide();
        });
    });

}); // end document ready

/* jQuery css bezier animation support -- Jonah Fox */
(function ($) {

    $.path = {};

    var V = {
        rotate: function (p, degrees) {
            var radians = degrees * Math.PI / 180,
                c = Math.cos(radians),
                s = Math.sin(radians);
            return [c * p[0] - s * p[1], s * p[0] + c * p[1]];
        },
        scale : function (p, n) {
            return [n * p[0], n * p[1]];
        },
        add   : function (a, b) {
            return [a[0] + b[0], a[1] + b[1]];
        },
        minus : function (a, b) {
            return [a[0] - b[0], a[1] - b[1]];
        }
    };

    $.path.bezier = function (params, rotate) {
        params.start = $.extend({angle: 0, length: 0.3333}, params.start);
        params.end = $.extend({angle: 0, length: 0.3333}, params.end);

        this.p1 = [params.start.x, params.start.y];
        this.p4 = [params.end.x, params.end.y];

        var v14 = V.minus(this.p4, this.p1),
            v12 = V.scale(v14, params.start.length),
            v41 = V.scale(v14, -1),
            v43 = V.scale(v41, params.end.length);

        v12 = V.rotate(v12, params.start.angle);
        this.p2 = V.add(this.p1, v12);

        v43 = V.rotate(v43, params.end.angle);
        this.p3 = V.add(this.p4, v43);

        this.f1 = function (t) {
            return (t * t * t);
        };
        this.f2 = function (t) {
            return (3 * t * t * (1 - t));
        };
        this.f3 = function (t) {
            return (3 * t * (1 - t) * (1 - t));
        };
        this.f4 = function (t) {
            return ((1 - t) * (1 - t) * (1 - t));
        };

        /* p from 0 to 1 */
        this.css = function (p) {
            var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4 = this.f4(p), css = {};
            if (rotate) {
                css.prevX = this.x;
                css.prevY = this.y;
            }
            css.x = this.x = (this.p1[0] * f1 + this.p2[0] * f2 + this.p3[0] * f3 + this.p4[0] * f4 + .5) | 0;
            css.y = this.y = (this.p1[1] * f1 + this.p2[1] * f2 + this.p3[1] * f3 + this.p4[1] * f4 + .5) | 0;
            css.left = css.x + "px";
            css.top = css.y + "px";
            return css;
        };
    };

    $.path.arc = function (params, rotate) {
        for (var i in params) {
            this[i] = params[i];
        }

        this.dir = this.dir || 1;

        while (this.start > this.end && this.dir > 0) {
            this.start -= 360;
        }

        while (this.start < this.end && this.dir < 0) {
            this.start += 360;
        }

        this.css = function (p) {
            var a = (this.start * (p) + this.end * (1 - (p))) * Math.PI / 180,
                css = {};

            if (rotate) {
                css.prevX = this.x;
                css.prevY = this.y;
            }
            css.x = this.x = (Math.sin(a) * this.radius + this.center[0] + .5) | 0;
            css.y = this.y = (Math.cos(a) * this.radius + this.center[1] + .5) | 0;
            css.left = css.x + "px";
            css.top = css.y + "px";
            return css;
        };
    };

    $.fx.step.path = function (fx) {
        var css = fx.end.css(1 - fx.pos);
        if (css.prevX != null) {
            $.cssHooks.transform.set(fx.elem, "rotate(" + Math.atan2(css.prevY - css.y, css.prevX - css.x) + ")");
        }
        fx.elem.style.top = css.top;
        fx.elem.style.left = css.left;
    };

})(jQuery);